module.exports = __webpack_public_path__ + "static/media/Thermostat.3034dabb.jpg";